<template>
  <div class="relative h-full max-h-full w-full max-w-full">
    <Bar
      v-if="Array.isArray(chartData.datasets)"
      :data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
// https://vue-chartjs.org/examples/
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { upperFirst } from 'lodash-es'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    groupBy: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            display: this.groupBy === 'periode',
            stacked: true
          },
          y: {
            stacked: true
          }
        }
      }
    }
  },
  watch: {
    groupBy(newVal) {
      // Update the chart options reactively when groupBy changes
      this.chartOptions.scales.x.display = newVal === 'periode'
    }
  }
}
</script>
